import { renderInDocument } from '@spotahome/soyuz/client';

import FavoritesPage from './main';

renderInDocument(FavoritesPage);
